import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import {
  bootstrapSucceeded,
  initiatePaymentForm,
  onPaymentMethodReady,
  onTranslationsReady,
  PaymentMethodState,
} from '@cashier/cashier-data-access';
import {
  Account,
  CashierConfiguration,
  PaymentTypes,
} from '@cashier/cashier-model';

import { InitialAmountProvider } from '../utils';

const fillPaymentFormListener = createListenerMiddleware();

fillPaymentFormListener.startListening({
  matcher: isAnyOf(onPaymentMethodReady, onTranslationsReady),
  effect: (_, listenerApi) => {
    const {
      cashierConfiguration: {
        amount: staticAmount,
        initialAmount,
        paymentType,
      },
      paymentMethod: {
        paymentMethod,
        accounts,
        areTranslationsReady,
        isPaymentMethodReady,
      },
    } = listenerApi.getState() as {
      cashierConfiguration: CashierConfiguration;
      paymentMethod: PaymentMethodState;
    };

    if (!isPaymentMethodReady) {
      return;
    }

    if (!areTranslationsReady) {
      return;
    }

    listenerApi.dispatch(bootstrapSucceeded());

    const { show_account_form } = paymentMethod;

    const availableAccounts: Account[] = show_account_form ? accounts : [];

    const account = availableAccounts[0] || null;

    const prefilledAmount = InitialAmountProvider.provide(
      staticAmount,
      initialAmount,
      {
        account,
        paymentType: paymentType as PaymentTypes,
      },
    );

    listenerApi.dispatch(
      initiatePaymentForm({
        account,
        amount: prefilledAmount,
      }),
    );
  },
});

export const fillPaymentFormMiddleware = fillPaymentFormListener.middleware;
